import React from 'react'
import * as S from './react-stories.styles';

interface HeaderViewProps {
    profileImage: string;
    heading: string;
    subheading: string
}

export const Header = (header: HeaderViewProps) => {
    return (
        <S.Header>
            <S.HeaderImageWrapper>
                <S.HeaderImage src={header.profileImage} alt="header"></S.HeaderImage>
            </S.HeaderImageWrapper>
            <S.HeaderContent>
                <S.HeaderTitle>{header.heading}</S.HeaderTitle>
                <S.HeaderSubTitle>{header.subheading}</S.HeaderSubTitle>
            </S.HeaderContent>
        </S.Header>
    )
}